import { blockType } from "../constants";
import { MarkdownTextBlockSchema } from "../schema";
import type { MarkdownText } from "../types";

export const create: MarkdownText["create"] = () => {
  return MarkdownTextBlockSchema.parse({
    type: blockType,
    config: {
      content:
        "# Sign up for a demo\n\nSubmit the form below. Once submitted, you'll receive a calendar invite for a 30-minute demonstration.",
      textAlign: "center",
      style: {
        width: "narrow",
        alignment: "center",
      },
    },
  });
};
